import { useStaticQuery, graphql } from 'gatsby';

const useMerch = () => {
    const {
        allSanityMerchItem: { nodes: merchItems },
        allSanityMerchCategory: { nodes: merchCategories },
    } = useStaticQuery(graphql`
        query {
            allSanityMerchItem {
                nodes {
                    title {
                        en
                        se
                    }
                    price {
                        value
                        currency
                    }
                    image {
                        image {
                            ...ImageWithPreview
                        }
                        alt
                    }
                    section {
                        title {
                            se
                            en
                        }
                    }
                    category {
                        id
                    }
                    url
                }
            }
            allSanityMerchCategory {
                nodes {
                    id
                    title {
                        se
                        en
                    }
                }
            }
        }
    `);

    return { merchCategories, merchItems };
};

const useAllMerchItems = () => {
    const { merchItems } = useMerch();

    return merchItems;
};

const useAllMerchCategories = () => {
    const { merchCategories } = useMerch();

    return merchCategories;
};

export { useAllMerchItems, useAllMerchCategories };
